module.exports = __webpack_public_path__ + "static/media/registra_ponto_mobile.5cbaef7b.mp4";